import { Grid2, Typography } from "@mui/material";
import { useAppSelector } from "../../../app/hooks";
import type { CardType } from "../domain/data/models/card-type";
import { useTranslation } from "react-i18next";
import React from "react";

export default function RevealedCards() {
  const {t} = useTranslation()
  const { pickedCardsIndex, cards, readingResult } = useAppSelector((state) => state.TarotSlice)
  
  return (
    <Grid2 container spacing={2}>
      {pickedCardsIndex.map((card, index) => {
        const indexCard = card.index*(card.row + 1);
        console.log({indexCard});
        
        const c: CardType = cards[indexCard]
        return (
          <React.Fragment key={`revealed_card_${index}`}>
            <Grid2 size={4} key={`revealed_card_${index}`}>
              <img src={c.image} alt="" />
              {readingResult === undefined &&  <Typography variant="h6" textAlign={'center'} color="#dcb65a">
                {t(`card.titles.${c.title}`)}
              </Typography>}
            </Grid2>
            {readingResult !== undefined && <Grid2 size={8} display={'flex'} flexDirection={'column'} justifyContent={'center'}>
              <Typography variant="h6" textAlign={'center'} color="#dcb65a">
                {t(`card.titles.${c.title}`)}
              </Typography>
              <div className="ast_blog_info_details">
                {readingResult[`card${index+1}`] ?? ""}
              </div>
            </Grid2>}
          </React.Fragment>
        )}
      )}
      {readingResult !== undefined && <>
        <div>
          <Typography variant="h6" textAlign={'center'} color="#dcb65a">
            {t('holistic_read')}
          </Typography>
          <div className="ast_blog_info_details">{readingResult.holistic_reading}</div>
        </div>
      </>}
    </Grid2>
  )
}